import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { AppReloadViewComponent } from './app-reload-view/app-reload-view.component';
import { AppReloadSetupService } from './services/executables/app-reload-setup/app-reload-setup.service';

const views = [AppReloadViewComponent];

const components = [...views];

const executables = [AppReloadSetupService];

const providers = [...executables];

@Addin({
  name: 'AppReload'
})
@NgModule({
  declarations: [...components],
  providers,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class AppReloadModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
